import { DisplayAmount } from "components/display/amount";
import { TooltipInfo } from "components/info-tooltip";
import { Card, CardContent } from "ui/components/card";
import { usePrivacy } from "contexts/privacy";
import { maskPrivacyAmount } from "utils/utils";


export function EvtStatsAmoundDisplayWithCurrencyCard({
  label,
  data,
  description,
  info,
}) {
  const { privacyOn } = usePrivacy();
  return (
    <Card className="rounded-xl shadow-none">
      <CardContent className="flex flex-col gap-2 md:gap-3 ">
        <div className="flex items-center gap-1">
          <h3 className="font-semibold text-primary">{label}</h3>
          {info && <TooltipInfo info={info} /> }
        </div>
        <span className="text-3xl md:text-4xl font-bold text-foreground">
          {data && (
            <>
              {privacyOn ? (
                <>
                  <span>{maskPrivacyAmount(data.value)}</span>
                  <span className="text-muted-foreground text-2xl ml-1">
                    {data.currency}
                  </span>
                </>
              ) : (
                <>
                  <DisplayAmount value={data.value} />
                  <span className="text-muted-foreground text-2xl ml-1">
                    {data.currency}
                  </span>
                </>
              )}
            </>
          )}
        </span>

        {description && (
          <p className="text-base text-muted-foreground">{description}</p>
        )}
      </CardContent>
    </Card>
  );
}
